<!-- Editor item new design -->

<div
  class="group w-full border-b border-neutral-300 py-4 text-neutral-800 transition-colors"
>
  <!-- Mobile Layout -->
  <div class="flex flex-col gap-1 lg:hidden">
    <ng-container
      [ngTemplateOutlet]="editorContent"
      [ngTemplateOutletContext]="{
        containerClass: 'flex items-start justify-between',
      }"
    ></ng-container>
  </div>

  <!-- Desktop Layout -->
  <div class="hidden lg:grid lg:grid-cols-4 lg:items-center">
    <ng-container
      [ngTemplateOutlet]="editorContent"
      [ngTemplateOutletContext]="{ containerClass: 'contents' }"
    ></ng-container>
  </div>
</div>

<ng-template #editorContent let-containerClass="containerClass">
  <!-- Name column -->
  <div [class]="containerClass">
    <div
      class="text-lg font-medium transition-all duration-300 group-hover:text-gray-400 lg:col-span-2"
    >
      {{ editor() | formatAuthorName }}
    </div>
    <!-- Mobile arrow -->
    <div
      class="h-3 w-3 transition-all duration-300 group-hover:translate-x-1 lg:hidden"
    >
      <img
        [attr.alt]="'pages.editors.viewDetails' | translate"
        src="assets/icons/diagonal_arrow_icon.svg"
      />
    </div>
  </div>

  <!-- Combined info column -->
  <div class="lg:col-span-1">
    <div
      class="flex gap-1 text-base transition-all duration-300 group-hover:text-gray-400 lg:text-lg"
    >
      <span>{{ editor().company_name }} {{ editor().department }}</span>
    </div>
  </div>

  <!-- Arrow column -->
  <div class="hidden lg:col-span-1 lg:flex lg:justify-end">
    <div class="h-3 w-3 transition-all duration-300 group-hover:translate-x-1">
      <img
        [attr.alt]="'pages.editors.viewDetails' | translate"
        src="assets/icons/diagonal_arrow_icon.svg"
      />
    </div>
  </div>
</ng-template>
